export { BrandValuesStrip } from "./BrandValuesStrip";
export type { BrandValuesStripProps, BrandValueItem } from "./BrandValuesStrip";
